.optionRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);

  // Checkbox is presentational — the row click owns selection.
  :global(.ant-checkbox-wrapper) {
    pointer-events: none;
  }
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-4);
  color: var(--text-muted);
}
